export const alertConstants = {
    ALERT_SHOW: "alert_show",
    ALERT_HIDE: "alert_hide",
}